module.exports = __webpack_public_path__ + "img/partner_fetishwerk.473088e3.jpeg";